import { render, staticRenderFns } from "./Bind_email.vue?vue&type=template&id=5760ded3&scoped=true&"
import script from "./Bind_email.vue?vue&type=script&lang=js&"
export * from "./Bind_email.vue?vue&type=script&lang=js&"
import style0 from "./Bind_email.vue?vue&type=style&index=0&id=5760ded3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5760ded3",
  null
  
)

export default component.exports